/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur mon site personnel ! Je suis Juslin KOMENAN, un développeur full-stack passionné spécialisé dans la création d'applications web dynamiques et réactives. Explorez mon portfolio, lisez mon blog et n'hésitez pas à me contacter !`)
};

const en_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to my personal website! I'm Juslin KOMENAN, a passionate full-stack developer specializing in building dynamic and responsive web applications. Explore my portfolio, read my blog, and feel free to get in touch!`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("description", locale)
	if (locale === "fr") return fr_description(inputs)
	return en_description(inputs)
};